( function ( _s ) {
	_s( document ).ready( () => {
		const _header = _s( '#app > header' );

		const setBodyTopPadding = () => {
			const headerHeight = _header.outerHeight();

			window.setRootProperty( '--body-top-padding', headerHeight + 'px' );
		};

		_s( window ).on( 'fr:set-body-top-padding', () => {
			setBodyTopPadding();
		} );
	} );
} )( window._s );
